import styled from 'styled-components';

export const EXTRA_AREA = 1.15;

/* eslint-disable max-len */
export const InstallationThresholdText = (installationThresholdValue) => `Delivery and Basic Installation is included with a 
qualifying purchase in select markets . You may incur additional installation costs depending on your location 
or if your total is less than $${installationThresholdValue}.`;

export const desktopMinWidth = '1025px';
export const desktop = '1024px';
export const tablet = '768px';
export const mobile = '320px';
export const mobileMaxWidth = '767px';
export const tabletMaxWidth = '1023px';
export const minWidth = '300px';
export const maxWidth = '1440px';
export const ipadProMaxHeight = '1366px';

export const resetSyle = '1px solid #999999';
export const errorStyle = '1px solid #D81118';
export const borderStyle = '3px';

export const SortCarpetBy = {
  PriceAsc: 'PriceAsc',
  PriceDesc: 'PriceDesc',
  Popularity: 'Popularity',
};

export const SwatchObjPropertyPaths = {
  sequence: 'sequence',
  price: 'priceSquareFoot',
  name: 'shortLabel',
};

export const SortOrder = {
  Asc: 'asc',
  Desc: 'desc',
};

export const Divider = styled.div`
  border-bottom: 1px solid #ccc;
  margin: 0.5rem -2rem 1.5rem -2rem;
  padding-bottom: 0px;
`;
export const SolidDivider = styled.div`
  border-bottom: 3px solid #ccc;
 /*  margin: -4.5rem 0rem 1.5rem 0rem; */
  padding-bottom: 0px;
`;

export const analyticConstants = {
  fetchStores: 'fetch stores',
  setStores: 'set store',
  storeClick: 'StoreLocation',
  viewMoreClick: 'View More Stores',
};
